import { repeatCallEntityName } from '../../../backend/config/classifiers';
import { TextCell } from '@juvare/common-data-table-ui/DataTable';
import { ClassifierAdminPage, SlideoutFields } from '@juvare/platform-sdk-react/ui/features/classifiers';
import { capitalize } from '@mui/material';
import React from 'react';
const tableColumns = [
    {
        headerLabel: 'Repetitions',
        sortKey: 'name',
        cellFunction: (row) => React.createElement(TextCell, null, row.columns.name),
    },
    {
        headerLabel: 'Value',
        sortKey: 'value',
        cellFunction: (row) => React.createElement(TextCell, null, row.columns.value),
    },
    {
        headerLabel: 'Status',
        sortKey: 'status',
        cellFunction: (row) => React.createElement(TextCell, null, capitalize(row.columns.status)),
    },
];
function getEntityTitle(row) {
    return row.columns.name;
}
const EntityDetailsComponent = (props) => {
    return React.createElement(SlideoutFields, { fields: [{ label: 'Status', value: capitalize(props.response.data.status) }] });
};
const formConfig = {
    key: '!form',
    type: 'form',
    children: [
        {
            type: 'form.text',
            key: 'name',
            label: 'Repetitions',
            validate: {
                required: true,
            },
        },
        {
            type: 'form.number',
            key: 'value',
            label: 'Value',
            validate: {
                required: true,
            },
        },
        {
            type: 'form.select',
            key: 'status',
            label: 'Status',
            validate: {
                required: true,
            },
            values: [
                {
                    value: 'active',
                    label: 'Active',
                },
                {
                    value: 'deprecated',
                    label: 'Deprecated',
                },
                {
                    value: 'retired',
                    label: 'Retired',
                },
            ],
        },
    ],
};
const editFormConfig = {
    key: '!form',
    type: 'form',
    children: [
        {
            type: 'form.text',
            key: 'name',
            label: 'Repetitions',
            disabled: true,
        },
        {
            type: 'form.number',
            key: 'value',
            label: 'Value',
            disabled: true,
        },
        {
            type: 'form.select',
            key: 'status',
            label: 'Status',
            validate: {
                required: true,
            },
            values: [
                {
                    value: 'active',
                    label: 'Active',
                },
                {
                    value: 'deprecated',
                    label: 'Deprecated',
                },
                {
                    value: 'retired',
                    label: 'Retired',
                },
            ],
        },
    ],
};
export const RepeatCallAdminPage = () => {
    return (React.createElement(ClassifierAdminPage, { entity: repeatCallEntityName, title: 'Repeat Call', tableColumns: tableColumns, fullTextSearchField: 'search', getEntityTitle: getEntityTitle, entityDetailsComponent: EntityDetailsComponent, formConfig: formConfig, editFormConfig: editFormConfig }));
};
